import { render, staticRenderFns } from "./Learningrecords.vue?vue&type=template&id=8c1a41d8"
import script from "./Learningrecords.vue?vue&type=script&lang=js"
export * from "./Learningrecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports